<template>
  <div>
    <h3 v-if="showTitle" class="mb-5">
      Lote: <span class="text-primary">{{ plot.name }}</span> - Emergencia
      <button title="Editar" class="btn btn-link btn-sm btn-fill btn-wd" @click="showEditForm">
        <i class="fas fa-pen"></i>&nbsp;Editar
      </button>
    </h3>

    <h3 v-else class="mb-4">Datos Emergencia</h3>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <p class="h5">Fecha de registro</p>
        <p>{{ plot.emergence.createdAt | date }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <p class="h5">Plantas por metro</p>
        <p v-if="plot.emergence.plantsPerMeter">{{ plot.emergence.plantsPerMeter }}</p>
        <p v-else>-</p>
      </div>

      <div class="col-md-6 col-sm-12">
        <p class="h4">
          Densidad de plantas
          <span v-if="plot.groovesDistance" class="font-weight-400">
            (Distanciamiento entre surcos: {{ plot.groovesDistance | decimals }} cm.)
          </span>
          <span v-else class="text-danger small font-weight-400">
            Se debe carga la distancia entre surcos para el calculo
          </span>
        </p>
        <p>{{ plot.emergence.plantsPerMeter | plantsDensity(plot.groovesDistance) }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <p class="h5">Fetilización nitrogenada <span class="text-muted">[Kg/Ha]</span></p>
        <p v-if="plot.emergence.nitrogenFertilization">
          {{ plot.emergence.nitrogenFertilization }} - {{ plot.emergence.fertilizationDosis }}&nbsp;<small
            >[Kg/HA]</small
          >
        </p>
        <p v-else>-</p>
      </div>
      <div class="col-md-6 col-sm-12">
        <p class="h5">Heladas</p>
        <p v-if="plot.emergence.frost">Si</p>
        <p v-else>-</p>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <p class="h5">Control de plagas</p>
        <p v-if="plot.emergence.pestControl">
          {{ plot.emergence.pestControl }}
        </p>
        <p v-else>-</p>
      </div>
      <div class="col-sm-12 col-md-6">
        <p class="h5">Control de malezas</p>
        <p v-if="plot.emergence.weedControl">
          {{ plot.emergence.weedControl }}
        </p>
        <p v-else>-</p>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <p class="h5">Granizos</p>
        <p v-if="plot.emergence.hailStorms">Si</p>
        <p v-else>-</p>
      </div>
      <div class="col-sm-12 col-md-6">
        <p class="h5">Precipitaciones</p>
        <p>{{ plot.emergence.rainfall }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <p class="h5">Temperaturas promedio</p>
        <p>{{ plot.emergence.averageTemperature }}</p>
      </div>
      <div class="col-sm-12 col-md-6">
        <p class="h5">Golpes de calor</p>
        <p v-if="plot.emergence.heatStrokes">Si</p>
        <p v-else>-</p>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <h4 class="mt-3 mb-3">Enfermedades</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <p class="h5">Tizón</p>
        <p v-if="plot.emergence.tizon">Si</p>
        <p v-else>-</p>
      </div>
      <div class="col-sm-12 col-md-6">
        <p class="h5">Helminthosporium</p>
        <p v-if="plot.emergence.helminthosporium">Si</p>
        <p v-else>-</p>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <p class="h5">Roya</p>
        <p v-if="plot.emergence.roya">Si</p>
        <p v-else>-</p>
      </div>
      <div class="col-sm-12 col-md-6">
        <p class="h5">Rayado fino</p>
        <p v-if="plot.emergence.cornStreak">Si</p>
        <p v-else>-</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },

    plot: {
      type: Object,
      default: () => null,
    },
  },

  methods: {
    showEditForm() {
      this.$emit('edit');
    },
  },
};
</script>
